import { IApp, IApps } from "model/app/app";
import { IRootState } from "redux/reducer";
import { createSelector } from "reselect";
import { IAppsState } from "./appsSlice";

export const getApps = (state: IRootState): IApps => state.apps.apps;

export const getAppByBundleId = (bundleId: string) =>
  createSelector(getApps, (apps): IApp => apps[bundleId]);

export const getAppsState = (state: IRootState): IAppsState => state.apps;
